if (!customElements.get('variant-options-table')){
  customElements.define('variant-options-table', class VariantOptionsTable extends HTMLElement {
    constructor() {
      super();
      this.addToCartBtn = this.querySelector('button[name="bulk-add"]');
      this.miniCart = document.querySelector("mini-cart");
    }
    
    connectedCallback() {
      // Listen to button click
      this.addToCartBtn.addEventListener('click', (e) => {
        e.preventDefault();
        
        const productsToCart = this.checkItems();
        console.log(productsToCart);
        
        if (productsToCart.length > 0) {
          this.handleAddToCart(productsToCart);
        }
      });
    }
    
    checkItems() {
      const table = this.querySelector("#variant-table"); 
      const rows = table.querySelectorAll("quantity-with-buttons");
      const productsToBeAdded = [];
      for (const row of rows) {
        const productQuantity = row.querySelector(".quantity__input").value;
        const variantID = row.getAttribute("data-variant-id");
  
        if (parseInt(productQuantity) > 0) {
          productsToBeAdded.push({ id: variantID, quantity: productQuantity });
        } 
      }
      return productsToBeAdded; 
    }
    
    clearUpQuantityFields(){
        const table = this.querySelector("#variant-table"); 
        const rows = table.querySelectorAll("quantity-with-buttons");
        for (const row of rows) {
            row.clearField();
        }
    }
  
    async handleAddToCart(products) {
      this.addToCartBtn.classList.add('disabled', 'loading');
      this.addToCartBtn.setAttribute('aria-disabled', true);
  
      const sections = this.getSectionsToRender().map((section) => section.section);
  
      let formData = {
        'items': products,
        "sections": sections
      };
    
      fetch(`${routes.cart_add_url}.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      })
      .then(response => response.json())
      .then((response) => {
        if (response.status) {
          console.error(response.description);
          return;
        }
  
        if (this.miniCart) {
          this.miniCart.renderContents(response);
          this.clearUpQuantityFields();
        }
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        this.addToCartBtn.classList.remove('disabled', 'loading');
        this.addToCartBtn.setAttribute('aria-disabled', false);
      });
    }
  
    getSectionsToRender() {
      return [
        {
          id: 'mini-cart',
          section: 'mini-cart',
          selector: '.shopify-section'
        },
        {
          id: 'cart-icon-bubble',
          section: 'cart-icon-bubble',
          selector: '.shopify-section'
        },
        {
          id: 'cart-live-region-text',
          section: 'cart-live-region-text',
          selector: '.shopify-section'
        }
      ];
    }
  })
}

if (!customElements.get('quantity-with-buttons')){
  customElements.define('quantity-with-buttons', class QuantityWithButton extends HTMLElement {
    constructor() {
        super();

        this.input = this.querySelector('input[name="quantity"]');
        this.minusBtn = this.querySelector('button[name="minus"]');
        this.plusBtn = this.querySelector('button[name="plus"]');
        this.quantity = 0;
        this.policy = this.getAttribute('data-policy');
        this.stock = parseInt(this.getAttribute('data-stock'), 10);
        this.management = this.getAttribute('data-management');
        if(this.management){
            console.log("management",this.management);
        }
      }
      
      connectedCallback() {
        // Listen to button click
        this.minusBtn.addEventListener('click', this.handleMinus.bind(this));
        this.plusBtn.addEventListener('click', this.handlePlus.bind(this));
      }

      clearField() {
        this.quantity = 0;
        this.input.value = 0;
      }

      handleMinus() {
        if(this.quantity == 0) return;

        let newQuantity = this.quantity - 1;
        if(this.management && this.policy != 'continue'){
            newQuantity = Math.max(0, Math.min(newQuantity, stock));
        }else {
            newQuantity = Math.max(0, newQuantity);
        }

        this.quantity = newQuantity;
        this.input.value = newQuantity;
      }

      handlePlus() {
        let newQuantity = this.quantity + 1;
        if(this.management && this.policy != 'continue'){
            newQuantity = Math.max(0, Math.min(newQuantity, stock));
        }else {
            newQuantity = Math.max(0, newQuantity);
        }

        this.quantity = newQuantity;
        this.input.value = newQuantity;
      }
  })
}
